import React, { useState } from 'react';
import styles from './style';

const ButtonRounded = (props) => {
  const { children, text, color, textColor, onClick, hoverColor, hoverStyle, border, size, style, padding, width, ...rest } = props;

  const [hover, setHover] = useState(false);

  let buttonStyles = { ...styles.buttonRounded };
  if (color) {
    buttonStyles.backgroundColor = color;
  }
  if (textColor) {
    buttonStyles.color = textColor;
  }
  if (border) {
    buttonStyles.borderColor = border;
  }
  if (padding) {
    buttonStyles.padding = padding;
  }
  if (width) {
    buttonStyles.width = width;
  }
  if (size) {
    buttonStyles.fontSize = size;
  }
  if (style) {
    buttonStyles = { ...buttonStyles, ...style };
  }
  let buttonHoverStyle = {
    ...buttonStyles,
    backgroundColor: hoverColor || 'none',
  }
  if (hoverStyle) {
    buttonHoverStyle = { ...buttonHoverStyle, ...hoverStyle };
  }

  return (
    <button
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      type="button"
      style={
        hover
          ? { ...buttonHoverStyle }
          : { ...buttonStyles }
      }
      onClick={onClick}
      {...rest}
    >
      {text || children}
    </button>
  );
};

export default ButtonRounded;
